export default function PaymentReceivedIcon() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Circle */}
            <circle cx="12" cy="12" r="11" />

            {/* Checkmark */}
            <path d="M8 12.5l3 3 7-7" />
        </svg>
    );
}
